import React, { useEffect } from 'react';

import './Radio.scss'

export const Comment = `
/**
 *
 * props の定義
 *
 * [data-*]
 * 		dataset			... [act] で指定の処理から e.target.dataset.json として呼び出したいJSON文字列
 *
 * [set]
 *    	key           		...	key監視対象
 *		name				...	ラジオボタンに設定する id、および name 属性の指定の文字列
 *		value				... 項目として設定する内容
 *		default				...	初期設定でチェックされている項目番号
 *		title				...	ラジオボタンのタイトルに設定する文字列
 *		layout 				... horizontal or vertical ラジオボタンのレイアウトタイプ
 *		class 				... ラジオボタンに適用するクラス名
 *
 * [act]
 * 		onchange			...	選択項目変更時に実行したい処理
 *
 *　例)
 *		<Radio
 *	 		name="radio"
 *	 		value={Object.keys(Constants.CHECK_VALUES)}
 *	 		title={Object.values(Constants.CHECK_VALUES)}
 *	 		default={0}
 *	 		onchange={onChange}
 *			className="radio"
 *			type="horizontal"
 * 		/>
 *
 */
`

export const Radio = (props) => {
	// 追加処理があれば実行
	const onChange = (e) => props.onchange && ((props.dataset) ? props.onchange(e) : props.onchange(e.target.value))

	// コンポーネントの返却
	return (
		<div key={props.key} id="ev_radio" className={" " + (props.type && props.type) + " " + (props.className && props.className)}>
			{props.value.map((value,index) => (
				<div key={index} className={"radio-wrapper radio-"+props.name}>
					{props.isLoading ? 
					<div className='radio-input loading'></div>
					: 
					<input
						className={"radio-input"}
						type="radio"
						name={props.name}
						id={props.name+index}
						value={value}
						checked={props.checked == value}
						disabled={props.disabled}
						/* act */
						onChange={onChange}
					/>
					}
					<label
						key={index}
						className={"radio-label"}
						htmlFor={props.name+index}
					>{props.title[index]}</label>
				</div>
			))}
		</div>
	);
}
export default Radio
